import {FC} from 'react'
import {useLocation} from 'react-router'
import {Link} from 'react-router-dom'
import clsx from 'clsx'
import {checkIsActive, KTIcon} from '../../../../helpers'

type Props = {
  title:string,
  id: any,
  Func:any,
  icon?:string
  img?:string
  hasBullet?:boolean
}

const MenuItemCTX: FC<Props> = ({title,Func,id,icon,img,hasBullet=false}) => {
  const {pathname} = useLocation()

  return (
    <div className='menu-item me-lg-1' onClick={()=> Func(id,title)}>
      <a
        className={clsx('menu-link py-3')}  
      > 
        {icon && (
          <span className='menu-icon'>
            <KTIcon iconName={icon} className='fs-2' />
          </span>
        )}
        {img && (
          <span className='menu-icon'>
            <img src={img} alt="" className='h-55px'/>
          </span>
        )}
         {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        <span className='menu-title text-marino'>{title}</span>
      </a>
    </div>
  )
}

export {MenuItemCTX}
